// Se conservan los tipos, iconos y colores de las gráficas originales.
const groupColors = {
  pending: {
    NOC: "warning",
    Aseguramiento: "primary",
    SAC: "info",
    Soporte: "dark",
    Desarrollo: "secondary",
    "Sin grupo": "error",
  },
  resolved: {
    NOC: "warning",
    Aseguramiento: "success",
    SAC: "primary",
    Soporte: "info",
    Desarrollo: "dark",
    "Sin grupo": "secondary",
  },
  closed: {
    NOC: "info",
    Aseguramiento: "success",
    SAC: "primary",
    Soporte: "warning",
    Desarrollo: "dark",
    "Sin grupo": "secondary",
  },
};
export function timelineChart(summary, type, offset = 0) {
  const buckets = summary.history?.[type] || {};
  const available = Object.keys(buckets).sort();
  const months = [];
  if (available.length) {
    let cursor = available[0];
    const last = available[available.length - 1];
    while (cursor <= last) {
      months.push(cursor);
      const [year, month] = cursor.split("-").map(Number);
      cursor = month === 12 ? `${year + 1}-01` : `${year}-${String(month + 1).padStart(2, "0")}`;
    }
  }
  const end = Math.max(0, months.length - offset * 12);
  const visible = months.slice(Math.max(0, end - 12), end);
  const groups = [...new Set(Object.values(buckets).flatMap(Object.keys))].sort();
  return {
    months: visible,
    previous: end > 12,
    next: offset > 0,
    labels: visible.map((month) =>
      new Intl.DateTimeFormat("es-CO", { month: "short", year: "numeric", timeZone: "UTC" }).format(
        new Date(`${month}-01T00:00:00Z`)
      )
    ),
    datasets: groups.map((group) => ({
      label: group,
      color: groupColors[type][group] || (type === "pending" ? "warning" : "primary"),
      data: visible.map((month) => buckets[month]?.[group] || 0),
    })),
  };
}
export function distributionCharts(summary) {
  const states = Object.entries(summary.states).sort((a, b) => b[1] - a[1]);
  const health = Object.entries(summary.groupHealth || {});
  const enCourse = health
    .filter(([, group]) => group.enCourse)
    .sort((a, b) => b[1].enCourse - a[1].enCourse);
  return {
    states: {
      labels: states.map(([name]) => name),
      datasets: [
        { label: "Cantidad de tickets", color: "info", data: states.map(([, count]) => count) },
      ],
    },
    enCourse: {
      labels: enCourse.map(([name]) => name),
      datasets: [
        {
          label: "Tickets en curso",
          color: "warning",
          data: enCourse.map(([, group]) => group.enCourse),
        },
      ],
    },
    sla: {
      labels: health.map(([name]) => name),
      datasets: [
        {
          label: "% >24 h de solución / resueltos y cerrados con tiempo válido",
          color: "error",
          data: health.map(([, group]) =>
            group.timed ? (100 * group.outside) / group.timed : null
          ),
        },
        {
          label: "% pendientes >3 días / todos los pendientes",
          color: "warning",
          data: health.map(([, group]) =>
            group.pending ? (100 * group.chronic) / group.pending : null
          ),
        },
      ],
    },
  };
}
